const reporter = store => next => action => {
  if (action.type === 'HOVER_CHANGED') {
    return next(action);
  }
  if (action.type === 'FETCH_USER_NOTIFICATIONS_SUCCESS') {
    return next(action);
  }
  console.group(action.type);
  console.log('%c prev state', 'color: gray', store.getState());
  console.log('%c action', 'color: blue', action);
  const returnValue = next(action);
  console.log('%c next state', 'color: green', store.getState());
  console.groupEnd(action.type);
  return returnValue;
};

export default reporter;
